import { useContext } from "react";

import { SkipGetShoppingBundleContext } from "../contexts";

const useSkipGetShoppingBundle = (): boolean =>
  useContext(SkipGetShoppingBundleContext);

export default useSkipGetShoppingBundle;
